import styled, { css } from 'styled-components'

export const Root = styled.div<{
  $isOpening: boolean
  $isSuspended: boolean | undefined
}>(({ theme, $isOpening, $isSuspended }) => {
  const baseStyles = css`
    position: fixed;
    z-index: ${theme.zIndex.level3};
    inset: 0;
    display: flex;
    background-color: rgba(54, 62, 92, 0);
    backdrop-filter: blur(0);
    overflow: hidden;
    transition:
      background-color ${theme.transition.duration.md} ease-in-out,
      backdrop-filter ${theme.transition.duration.md} ease-in-out;
  `

  const openingStyles =
    $isOpening &&
    css`
      background-color: rgba(54, 62, 92, 0.5);
      backdrop-filter: blur(8px);
    `

  const suspendedStyles =
    $isSuspended &&
    css`
      pointer-events: none;
    `

  return css`
    ${baseStyles}
    ${openingStyles}
      ${suspendedStyles}
  `
})

export const Container = styled.div<{ $isContentOpening: boolean; $lightBg: boolean }>(
  ({ theme, $isContentOpening, $lightBg }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: ${$lightBg ? theme.colors.white : theme.colors.gray100};
    overflow: hidden auto;
    transition: transform ${theme.transition.duration.md} ease-in-out;
    transform: translateY(${$isContentOpening ? '0' : '100%'});
    pointer-events: initial;
  `,
)
